<template slot-scope="scope">
  <!-- 职位 选择 -->
  <dialogModel
    title="选择职位"
    :visible.sync="PositionAndProfession"
    @handleClose="handleClose"
    @handleOk="handleUnderstand"
  >
    <div class="input-box">
      <el-select
          v-model="input"
          filterable
          remote
          placeholder="请输入关键词"
          :remote-method="remoteMethod"
          :loading="loading"
          @change="pestChange"
          @blur="handleBlur"
        >
          <el-option
            v-for="item in options"
            :key="item.id"
            :value="item.value"
            :label="item.label"
          >
          </el-option>
        </el-select>
    </div>
    <!-- 主体 -->
    <div class="main-body">
      <div class="left-menu">
        <div
          v-for="(item, index) in list"
          :key="index"
          :class="item.code == listSelect ? 'left-menu-Select' : ''"
          @click="handelClickMenu(item)"
        >
          {{ item.label }}
        </div>
      </div>
      <div class="right-Options">
        <!-- 右侧box -->
        <div
          class="MunicipalLevel-box"
          :style="TheCity.length == 0 ? 'height:50%' : ''"
        >
          <p
            v-for="(item, index) in TheCity"
            :key="index"
            :class="item.code == TheCitySelect ? 'TheCitySelect' : ''"
            @click="handelTheCitySelect(item)"
          >
            {{ item.label }}
          </p>
        </div>
        <!-- 右侧区 -->
        <div class="area-box">
          <p
            v-for="(item, index) in areaList"
            :key="index"
            :class="item.code == areaSelect ? 'TheCitySelect' : ''"
            @click="handelAreaSelect(item)"
          >
            {{ item.label }}
          </p>
        </div>
      </div>
    </div>
  </dialogModel>
</template>

<script>
// distinguish职位
// 引入接口
import {
  postGetPositionSelect, // 职位
  findPosition, //搜索职位
} from "../assets/api/indexl";
export default {
  props: {
    PositionAndProfession: {},
    positionCode: {},
  },
  components: {},
  data() {
    return {
      input: "", // 搜索框数据

      list: [], // 全  数据
      listSelect: "", //左侧菜单栏选中
      TheCity: [], //二级职位
      TheCitySelect: "", //二级职位选中
      areaList: [], //三级职位数据
      areaSelect: "", // 三级职位选中
      areaSelectName: "", // 三级职位选中 名

      options: [],
      value: [],
      listInput: [],
      loading: false, // 加载....
      states: [], //  门类数据列表
    };
  },
  watch: {
    // 监听弹窗打开状态
    PositionAndProfession: {
      async handler(newSs) {
        if (newSs !== true) return;
        // 先确保职位数据就绪，再做回显/默认选中
        await this.ensurePositionList();
        this.applyPositionSelection();
      },
    },
  },
  computed: {},
  created() {
    // 移除created中的接口调用，改为在弹窗打开时按需加载
  },
  methods: {
    async ensurePositionList() {
      if (
        !this.$store.getters.getPosition ||
        this.$store.getters.getPosition.length === 0
      ) {
        await this.postGetPositionSelect();
      } else {
        this.list = this.$store.getters.getPosition;
      }
    },
    applyPositionSelection() {
      var that = this;
      if (
        that.positionCode != undefined &&
        that.positionCode != null &&
        that.positionCode != ""
      ) {
        that.areaSelect = that.positionCode;
        for (var i in that.list) {
          for (var k in that.list[i].children) {
            for (var s in that.list[i].children[k].children) {
              if (
                that.list[i].children[k].children[s].code == that.positionCode
              ) {
                this.areaSelectName =
                  that.list[i].children[k].children[s].label;
                this.areaList = that.list[i].children[k].children;
                this.TheCitySelect = that.list[i].children[k].code;
                this.TheCity = that.list[i].children;
                this.listSelect = that.list[i].code;
              }
            }
          }
        }
      } else if (
        that.list &&
        that.list.length > 0 &&
        that.list[0] &&
        that.list[0].children
      ) {
        that.TheCity = that.list[0].children;
        that.listSelect = that.list[0].code;
        that.TheCitySelect = "";
        that.areaList = [];
        that.areaSelect = "";
        that.areaSelectName = "";
      }
    },
    // 失去焦点清空下拉选项
    handleBlur() {
      // 延迟清空，防止选中值时被清空
      setTimeout(() => {
        this.options = [];
      }, 300);
    },
    // 选择 门类名称完毕 获取需要的值
    pestChange(val) {
      // console.log(
      //   val,
      //   val.substring(val.lastIndexOf("-") + 1),
      //   val.substring(0, val.lastIndexOf("-"))
      // );
      // 使用 nextTick 确保选择完成后再清空选项
      this.$nextTick(() => {
        this.options = [];
        this.$emit(
          "handleUnderstand",
          0,
          val.substring(0, val.lastIndexOf("-")),
          val.substring(val.lastIndexOf("-") + 1)
        );
        this.TheCitySelect = "";
        this.areaSelect = "";
        this.areaSelectName = "";
        this.areaList = [];
        this.input = "";
      });
    },
    // 门类 远程搜索
    async remoteMethod(query) {
      // 远程搜索前调用接口，传入搜索的数据获取门类 
      var data = {};
      data.data = {
        name: query != "" ? query : "/",
      };
      if (data.data.keyword != "") {
        // 调用 获取门类接口
        await findPosition(data).then((res) => {
          this.states = res.data.list;
          this.listInput = this.states.map((item) => {
            return {
              value: `${item.level3Code}-${item.level3Name}`,
              label: `${item.level1Name}-${item.level2Name}-${item.level3Name}`,
              id: `${item.level3Code}`,
            };
          });
        });
      }
      // 组件 自带远程搜索的函数
      if (query !== "") {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.options = this.listInput.filter((item) => {
            return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
          });
        }, 200);
      } else {
        this.options = [];
      }
    },
    // 调用接口
    async postGetPositionSelect() {
      var data = {
        data: {},
      };
      const res = await postGetPositionSelect(data);
      // 拿到 数据
      this.list = res.data;
      // 将数据存储到Vuex
      this.$store.commit("SET_Position", res.data);

      // 给二级赋值
      // this.areaList = res.data[0].children[0].children;
      // 二级的默认选中状态
      // this.TheCitySelect = res.data[0].children[0].code;
    },
    //选择左侧一级
    handelClickMenu(item) {
      console.log(item);
      // 点击一级列表
      // 二级赋值
      this.TheCity = item.children;
      // 三级赋值
      // this.areaList = item.children[0].children;
      // 一级选中改变
      this.listSelect = item.code;
      this.TheCitySelect = "";
      this.areaSelect = "";
      this.areaSelectName = "";
      this.areaList = [];
      // 二级的默认选中状态
      // this.TheCitySelect = item.children[0].code;
    },
    // 选择 右上二级
    handelTheCitySelect(item) {
      // 点击二级
      if (this.TheCitySelect == item.code) {
        this.TheCitySelect = "";
        this.areaList = [];
        this.areaSelect = "";
        this.areaSelectName = "";
      } else {
        // 获取三级数据
        this.areaList = item.children;
        // 二级选中改变 （暂时不要二级选中状态）
        this.TheCitySelect = item.code;
      }
    },
    // 选择 右下三级
    handelAreaSelect(item) {
      if (item.code == this.areaSelect) {
        this.areaSelect = "";
        this.areaSelectName = "";
      } else {
        this.areaSelect = item.code;
        this.areaSelectName = item.label;
      }
    },
    // 弹窗关闭
    handleClose() {
      this.TheCitySelect = "";
      this.areaSelect = "";
      this.areaSelectName = "";
      this.areaList = [];
      this.$emit("handleClose", 0);
    },
    // 弹窗确认
    handleUnderstand() {
      if (this.areaSelect != "") {
        console.log(this.areaSelect, this.areaSelectName);
        this.$emit("handleUnderstand", 0, this.areaSelect, this.areaSelectName);
        this.TheCitySelect = "";
        this.areaSelect = "";
        this.areaSelectName = "";
        this.areaList = [];
      } else {
        // 没有选择职位不可点击确定
        this.$tool.PromptBox("warning", "请选择详细职位");
      }
    },
  },
};
</script>

<style scoped lang="less">
// 标题
.title {
  width: 100%;
  height: 90px;
  position: relative;

  display: flex;
  // 关闭按钮
  .Off-icon {
    width: 18px;
    height: 18px;
    background-image: url("../assets/imgs/guanbi.svg");
    background-size: 100% 100%;
    position: absolute;
    right: 10px;
    top: 10px;
  }
  .Text-title {
    height: 20px;
    width: 100px;
    line-height: 20px;
    margin: auto 0;
    font-family: PingFangSC-Medium;
    font-size: 16px;
    color: #409eff ;
    font-weight: 400;
    margin-left: 30px;
  }
  // 搜索框
  .input-box {
    width: 340px;
    height: 30px;
    line-height: 30px;
    margin: auto 0;
    margin-left: 70px;
    display: flex;
    position: relative;
    // input框的样式
    /deep/.el-input__inner {
      width: 250px !important;
      font-size: 16px;
      line-height: 30px;
      height: 30px !important;
      border: 1px solid #409eff ;
      background: #ffffff;
      // position: absolute;
      border-radius: 10px;
      z-index: 1;
    }
    // 搜索按钮样式
    .search_btn {
      font-size: 16px;
      color: #ffffff;
      font-weight: 400;
      line-height: 30px;
      background-color: #409eff ;
      width: 100px;
      height: 30px;
      border-radius: 10px;
      cursor: pointer;
      // position: absolute;
      // right: 0;
      display: flex;
      white-space: nowrap;
      div {
        width: 60px;
        height: 20px;
        line-height: 20px;
        margin: auto;
        display: flex;
        p {
          width: 20px;
          height: 20px;

          font-size: 18px;
        }
      }
    }
  }
}
// 内容主体
.main-body {
  width: 100%;
  height: 450px;
  display: flex;
  border-bottom: 1px dashed #409eff ;
  .left-menu::-webkit-scrollbar {
    display: none;
  }
  .left-menu {
    width: 175px;
    height: 100%;
    margin-left: 5px;
    overflow: hidden;
    overflow-y: scroll;
    // 火狐隐藏滚动条
    scrollbar-width: none;
    div {
      width: 100%;
      height: 35px;
      line-height: 35px;
      text-align: center;
      margin-bottom: 10px;
      margin-top: 10px;
      background: #ffffff;
      border-radius: 10px 0px 0px 10px;
      font-family: PingFangSC-Medium;
      font-size: 16px;
      color: #333333;
      font-weight: 400;
      cursor: pointer;
    }
    .left-menu-Select {
      background: #eeeeee;
      color: #409eff ;
    }
  }
  .right-Options::-webkit-scrollbar {
    display: none;
  }
  .right-Options {
    overflow: hidden;
    overflow-y: scroll;
    // 火狐隐藏滚动条
    scrollbar-width: none;
    flex: 1;
    height: 100%;
    background: #eeeeee;
    //二级 div
    .MunicipalLevel-box {
      //   width: 100%;
      //   height: 237px;
      border-bottom: 1px dashed #409eff ;
      margin: 20px 20px 0px 20px;
      display: flex;
      flex-wrap: wrap;
      p {
        min-width: 85px;
        padding-left: 8px;
        padding-right: 8px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        background: #ffffff;
        border: 1px solid #979797;
        border-radius: 5px;
        margin-right: 18px;
        margin-bottom: 18px;
        font-size: 12px;
        color: #333333;
        font-weight: 400;
        cursor: pointer;
      }
      .TheCitySelect {
        background: #409eff ;
        border: 1px solid #409eff ;
        color: #ffffff;
      }
    }
    // 区 县级
    .area-box {
      //   width: 100%;
      //   height: 237px;
      margin: 0px 20px 0px 20px;
      display: flex;
      flex-wrap: wrap;
      p {
        min-width: 85px;
        padding-left: 8px;
        padding-right: 8px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        background: #ffffff;
        border: 1px solid #979797;
        border-radius: 5px;
        margin-right: 20px;
        margin-top: 20px;
        font-size: 12px;
        color: #333333;
        font-weight: 400;
        cursor: pointer;
      }
      .TheCitySelect {
        background: #409eff ;
        border: 1px solid #409eff ;
        color: #ffffff;
      }
    }
  }
}
/deep/.el-button {
  width: 120px !important;
  height: 40px !important;
}
.el-button--primary {
  background: #409eff ;
  border: 1px solid #409eff ;
}
</style>
